export const platformBrandVoices = [
  {
    label: "Alex Hormozi",
    value: "alex_hormozi",
    description: "Direct, high-value insights, no-fluff business advice",
  },
  {
    label: "Andrew Chen",
    value: "andrew_chen",
    description: "Data-driven growth and startup insights",
  },
  {
    label: "Anne-Laure Le Cunff",
    value: "anne_laure",
    description: "Research-backed, mindful creator perspective",
  },
  {
    label: "Daniel Vassallo",
    value: "daniel_vassallo",
    description: "Authentic, transparent indie builder perspective",
  },
  {
    label: "David Ogilvy",
    value: "david_ogilvy",
    description: "Classic, persuasive, research-based copywriting",
  },
  {
    label: "David Perell",
    value: "david_perell",
    description: "Clear, thoughtful writing with powerful analogies",
  },
  {
    label: "Dickie Bush",
    value: "dickie_bush",
    description: "Clear, structured advice on writing and building",
  },
  {
    label: "Gary Vaynerchuk",
    value: "gary_vee",
    description: "High-energy, motivational, raw authenticity",
  },
  {
    label: "Jack Butcher",
    value: "jack_butcher",
    description: "Visual-first thinking, conceptual frameworks",
  },
  {
    label: "James Clear",
    value: "james_clear",
    description: "Evidence-based, systematic improvement advice",
  },
  {
    label: "Justin Welsh",
    value: "justin_welsh",
    description: "Practical solopreneur advice, actionable insights",
  },
  {
    label: "Marie Forleo",
    value: "marie_forleo",
    description: "Optimistic, actionable business & life advice",
  },
  {
    label: "Naval Ravikant",
    value: "naval_ravikant",
    description: "Philosophical, concise, wisdom-packed insights",
  },
  {
    label: "Paul Graham",
    value: "paul_graham",
    description: "Deep, analytical essays on startups and tech",
  },
  {
    label: "Pieter Levels",
    value: "pieter_levels",
    description: "Direct, transparent indie hacking, building in public",
  },
  {
    label: "Sahil Bloom",
    value: "sahil_bloom",
    description: "Educational, engaging threads with clear frameworks",
  },
  {
    label: "Sam Parr",
    value: "sam_parr",
    description: "Engaging storyteller, casual but sharp business insights",
  },
  {
    label: "Seth Godin",
    value: "seth_godin",
    description: "Concise, thought-provoking marketing wisdom",
  },
];
